module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown-nav cursor",
    class: {
      open: _vm.dropdown
    }
  }, [_c('div', {
    ref: "sectiondropdown",
    staticClass: "currentSection",
    on: {
      "click": function($event) {
        _vm.dropdown = !_vm.dropdown
      }
    }
  }, [_c('div', {
    staticClass: "graph-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "dropdown-title",
    domProps: {
      "innerHTML": _vm._s(_vm.sectionKey === 0 ? 'select a data set' : _vm.currentSection.title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dropdown-arrow"
  }, [_c('img', {
    attrs: {
      "src": '/img/arrow-b.svg'
    }
  })])]), _vm._v(" "), (_vm.dropdown) ? _c('div', {
    staticClass: "allSections"
  }, _vm._l((_vm.sections), function(section, index) {
    return _c('div', [_c('div', {
      staticClass: "dropdown-title",
      domProps: {
        "innerHTML": _vm._s(section.title)
      },
      on: {
        "click": function($event) {
          _vm.setKey(index)
        }
      }
    })])
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a3ee33f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionDropdown.vue
// module id = 300
// module chunks = 1